<template>
  <div class="auth-layout">
    <div class="auth-container">
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
// Layout minimal pour les pages d'authentification
</script>

<style scoped>
.auth-layout {
  @apply min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex items-center justify-center p-4;
}

.auth-container {
  @apply w-full max-w-md;
}
</style>

